import {
  BatchSchoolStatisticsBestReaderConditionListItem,
  BatchSchoolStatisticsBestReaderConditionListItemFromJSON
} from './BatchSchoolStatisticsBestReaderConditionListItem'

export interface BatchSchoolStatisticsBestReaderSelectItemResult {
  items: BatchSchoolStatisticsBestReaderConditionListItem
}

export function BatchSchoolStatisticsBestReaderSelectItemResultFromJSON(
  json: any
): BatchSchoolStatisticsBestReaderSelectItemResult {
  return {
    items: BatchSchoolStatisticsBestReaderConditionListItemFromJSON(json)
  }
}
